import { sanctumApi } from './authApi';
import { baseApi, baseFormDataApi } from '@/config/axios';
import {
  CarCandidatesResponse,
  CustomerInviteCodeParams,
  CustomerInviteCodeResponse,
  GenerateCustomerInviteCodeParams,
  GenerateCustomerInviteCodeResponse,
  InspectionCertificationsResponse,
  RegistCustomerParams,
  RegistCustomerResponse,
  RegisteredCheckParams,
  RegisteredCheckResponse,
} from '@/types/api/registerQRApi';

export const checkCustomerInviteCode = async (
  params: CustomerInviteCodeParams,
): Promise<CustomerInviteCodeResponse> => {
  await sanctumApi();
  return baseApi.put('/v1/customer/invite-code', params);
};

export const generateCustomerInviteCode = (
  params: GenerateCustomerInviteCodeParams,
): Promise<GenerateCustomerInviteCodeResponse> =>
  baseApi.post('/v1/customer/invite-code', params);

export const postRegisterCustomer = async (
  params: RegistCustomerParams,
): Promise<RegistCustomerResponse> => {
  await sanctumApi();
  return baseApi.post('/v1/customer/regist_customer', params);
};

export const postInspectionCertifications = async (
  params: FormData,
): Promise<InspectionCertificationsResponse> => {
  await sanctumApi();
  return baseFormDataApi.post(
    '/v1/customer/car/inspection-certifications',
    params,
  );
};

export const getCarCandidates = async (
  modelCode: string,
): Promise<CarCandidatesResponse> => {
  await sanctumApi();
  return baseApi.get('/v1/customer/car/car-candidates', {
    params: { model_code: modelCode },
  });
};

// 車検証読み込み時点で、同一ナンバープレートの車両が登録済みかを判定する
export const getRegisteredCheck = async (
  params: RegisteredCheckParams,
): Promise<RegisteredCheckResponse> => {
  await sanctumApi();
  return baseApi.get('/v1/customer/car/registered-check', { params });
};
